"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TextField_1 = require("@mui/material/TextField");
var MenuItem_1 = require("@mui/material/MenuItem");
var Box_1 = require("@material-ui/core/Box");
var styles_1 = require("@material-ui/core/styles");
var salesforceApi_1 = require("../../../apis/salesforceApi");
// import { UserContext } from 'globalState';
var react_context_hook_1 = require("react-context-hook");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    var _a, _b, _c, _d;
    return ({
        root: (_a = {
                display: 'flex',
                marginRight: 10,
                position: 'relative'
            },
            _a[theme.breakpoints.up('sm')] = {
                marginRight: 40,
            },
            _a),
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: (_b = {
                flexGrow: 1,
                display: 'none'
            },
            _b[theme.breakpoints.up('sm')] = {
                display: 'block',
            },
            _b),
        searchIcon: {
            padding: theme.spacing(0, 2),
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
            pointerEvents: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '&.right': {
                left: 'auto',
                right: 0,
                '& + $inputRoot $inputInput': {
                    paddingLeft: theme.spacing(2),
                    paddingRight: "calc(1em + " + theme.spacing(4) + "px)",
                },
            },
        },
        inputRoot: {
            color: 'inherit',
            width: '100%',
        },
        inputInput: (_c = {
                padding: theme.spacing(2, 2, 2, 0),
                paddingLeft: "calc(1em + " + theme.spacing(4) + "px)",
                transition: theme.transitions.create('width'),
                backgroundColor: theme.palette.common.white,
                width: 162,
                height: 35,
                borderRadius: 4,
                boxSizing: 'border-box'
            },
            _c[theme.breakpoints.down('sm')] = {
                width: 100,
            },
            _c['&:focus'] = (_d = {
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    borderColor: theme.palette.primary,
                    width: 235
                },
                _d[theme.breakpoints.down('sm')] = {
                    backgroundColor: theme.palette.common.white,
                    width: 162,
                },
                _d),
            _c),
        searchIconBox: {
            position: 'relative',
            '& $inputInput': {
                width: 35,
                borderRadius: 50,
                paddingLeft: 27,
                '&:focus': {
                    width: 235,
                    borderRadius: 4,
                    paddingLeft: "calc(1em + " + theme.spacing(4) + "px)",
                },
            },
            '& $searchIcon': {
                paddingLeft: 6,
                paddingRight: 6,
            },
        },
    });
});
var StorePickList = function () {
    var classes = useStyles();
    var _a = (0, react_context_hook_1.useStore)('ibcNumber'), ibcNumber = _a[0], setIbcNumber = _a[1];
    var _b = (0, react_context_hook_1.useStore)('currentStore'), currentStore = _b[0], setCurrentStore = _b[1];
    var _c = (0, react_context_hook_1.useStore)('availableStores'), availableStores = _c[0], setAvailableStores = _c[1];
    var emailClaim = (0, react_context_hook_1.useStore)('emailClaim')[0];
    var handleChange = function (event) {
        var storeId = event.target.value;
        setCurrentStore(availableStores.find(function (store) { return store.ibcNumber === storeId; }));
        setIbcNumber(storeId);
    };
    React.useEffect(function () {
        var isMounted = true;
        if (emailClaim) {
            salesforceApi_1.default.getIbcStoreChain(emailClaim).then(function (res) {
                if (isMounted) {
                    var response = res.data.data[0];
                    var stores = response.stores;
                    setAvailableStores(stores);
                    setCurrentStore(stores.find(function (store) { return store.ibcNumber === ibcNumber; }));
                }
            });
        }
        return function () { isMounted = false; };
    }, [emailClaim]);
    return (React.createElement(Box_1.default, { className: classes.root },
        React.createElement(TextField_1.default, { id: "outlined-select-currency", select: true, label: "Store", value: (currentStore === null || currentStore === void 0 ? void 0 : currentStore.ibcNumber) || {}, onChange: handleChange, size: "small", style: { width: 200 }, fullWidth: true }, availableStores && availableStores.map(function (option) { return (React.createElement(MenuItem_1.default, { key: option.ibcNumber, value: option.ibcNumber }, option.storeName)); }))));
};
exports.default = StorePickList;
//# sourceMappingURL=StorePickList.js.map